export const clearDecimals = (value?: number, digits: number = 2) => {
  if (!value) return 0

  if (digits === 0) {
    return parseInt(value.toString())
  }

  return Number(value.toFixed(digits))
}
